export const productSettings = {
    productName: process.env.REACT_APP_PRODUCT_NAME ?? "Land Acquisition",
    productId: process.env.REACT_APP_PRODUCT_ID ?? "LandAcquisition",
    isLandAcquisition : process.env.REACT_APP_PRODUCT_ID == null || process.env.REACT_APP_PRODUCT_ID == "LandAcquisition",
    isMegaView: process.env.REACT_APP_PRODUCT_ID == "MegaView"
};